var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCt1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 4,
    fill: "#FFE8E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_7147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9297 19.1816H45.0712V19.8795H22.9297V19.1816Z",
    fill: "#7E8595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9297 23.1055H45.0712V23.8033H22.9297V23.1055Z",
    fill: "#7E8595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8828 27.0293H42.1165V27.7272H25.8828V27.0293Z",
    fill: "#7E8595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0703 46.793H22.9288V46.0951H45.0703V46.793Z",
    fill: "#7E8595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0703 42.8691H22.9288V42.1713H45.0703V42.8691Z",
    fill: "#7E8595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1172 38.9453H25.8835V38.2475H42.1172V38.9453Z",
    fill: "#7E8595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7454 48.9725C44.9563 48.9725 44.3166 48.3328 44.3166 47.5436C44.3166 45.6237 43.8288 43.719 42.9056 42.0355C41.9826 40.3521 40.639 38.9166 39.0203 37.8843L27.4377 30.4976C25.4151 29.2077 23.7365 27.4141 22.5833 25.3108C21.43 23.2074 20.8203 20.8276 20.8203 18.4288C20.8203 17.6397 21.46 17 22.2491 17C23.0383 17 23.678 17.6397 23.678 18.4288C23.678 20.3488 24.1658 22.2535 25.0889 23.9369C26.012 25.6204 27.3555 27.0558 28.9742 28.0882L40.5568 35.4749C42.5793 36.7647 44.258 38.5583 45.4112 40.6617C46.5645 42.765 47.1741 45.1448 47.1741 47.5436C47.1743 48.3328 46.5346 48.9725 45.7454 48.9725Z",
    fill: "url(#paint0_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4111 40.6623C44.2578 38.559 42.5791 36.7653 40.5566 35.4755L28.9741 28.0888C27.3553 27.0565 26.0118 25.621 25.0888 23.9375C24.1656 22.2541 23.6778 20.3494 23.6778 18.4295C23.6778 17.8447 23.3264 17.3422 22.8233 17.1211C22.3202 17.3423 21.9688 17.8447 21.9688 18.4295C21.9688 20.8283 22.5784 23.2081 23.7316 25.3114C24.8849 27.4147 26.5636 29.2084 28.586 30.4982L40.1686 37.8849C41.7874 38.9172 43.1309 40.3527 44.054 42.0362C44.9771 43.7196 45.4649 45.6243 45.4649 47.5442C45.4649 48.129 45.8164 48.6315 46.3194 48.8526C46.8225 48.6314 47.174 48.129 47.174 47.5442C47.174 45.1454 46.5644 42.7657 45.4111 40.6623Z",
    fill: "url(#paint1_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5595 35.4743L35.3689 32.1641L32.6328 33.8085L39.0229 37.8838C39.6668 38.2945 40.2663 38.7699 40.814 39.2983H44.5611C43.4904 37.7809 42.1291 36.4754 40.5595 35.4743Z",
    fill: "url(#paint2_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2491 48.9725C21.46 48.9725 20.8203 48.3328 20.8203 47.5436C20.8203 45.1448 21.4299 42.765 22.5832 40.6617C23.7365 38.5583 25.4151 36.7647 27.4376 35.4749L39.0202 28.0882C40.6389 27.0558 41.9825 25.6204 42.9055 23.9369C43.8286 22.2535 44.3165 20.3488 44.3165 18.4288C44.3166 17.6397 44.9563 17 45.7454 17C46.5346 17 47.1743 17.6397 47.1743 18.4288C47.1743 20.8276 46.5646 23.2074 45.4114 25.3108C44.2581 27.4141 42.5794 29.2077 40.5569 30.4976L28.9743 37.8843C27.3555 38.9165 26.012 40.3521 25.089 42.0355C24.1659 43.719 23.678 45.6237 23.678 47.5436C23.678 48.3328 23.0383 48.9725 22.2491 48.9725Z",
    fill: "url(#paint3_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9761 37.8837L40.5587 30.4971C42.5812 29.2072 44.2599 27.4136 45.4131 25.3103C46.5664 23.2069 47.176 20.8271 47.176 18.4283C47.176 17.7943 46.763 17.2572 46.1916 17.0703C45.6201 17.2572 45.2071 17.7944 45.2071 18.4283C45.2071 20.3482 44.7192 22.2529 43.7961 23.9364C42.8731 25.6198 41.5295 27.0553 39.9108 28.0877L28.3282 35.4743C26.3057 36.7642 24.6271 38.5578 23.4738 40.6612C22.3206 42.7645 21.7109 45.1443 21.7109 47.5431C21.7109 48.1771 22.1239 48.7142 22.6954 48.9011C23.2669 48.7142 23.6799 48.177 23.6799 47.5431C23.6799 45.6232 24.1677 43.7185 25.0908 42.035C26.0139 40.3516 27.3573 38.9161 28.9761 37.8837Z",
    fill: "url(#paint4_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9995 29.8466C35.3626 29.8466 36.4677 28.7415 36.4677 27.3784C36.4677 26.0152 35.3626 24.9102 33.9995 24.9102C32.6363 24.9102 31.5312 26.0152 31.5312 27.3784C31.5312 28.7415 32.6363 29.8466 33.9995 29.8466Z",
    fill: "url(#paint5_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9974 29.4382C35.1351 29.4382 36.0573 28.5159 36.0573 27.3783C36.0573 26.2406 35.1351 25.3184 33.9974 25.3184C32.8598 25.3184 31.9375 26.2406 31.9375 27.3783C31.9375 28.5159 32.8598 29.4382 33.9974 29.4382Z",
    fill: "url(#paint6_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6715 25.5625C35.7392 25.9279 35.7253 26.3141 35.6151 26.6955C35.2368 28.005 33.8684 28.76 32.5588 28.3816C32.1775 28.2714 31.8433 28.0772 31.5703 27.825C31.7351 28.7146 32.3846 29.4802 33.3128 29.7484C34.6224 30.1267 35.9908 29.3718 36.3691 28.0623C36.6373 27.134 36.336 26.1763 35.6715 25.5625Z",
    fill: "url(#paint7_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.601 44.9872C29.9642 44.9872 31.0692 43.8821 31.0692 42.519C31.0692 41.1558 29.9642 40.0508 28.601 40.0508C27.2379 40.0508 26.1328 41.1558 26.1328 42.519C26.1328 43.8821 27.2379 44.9872 28.601 44.9872Z",
    fill: "url(#paint8_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6068 44.5788C29.7445 44.5788 30.6667 43.6566 30.6667 42.5189C30.6667 41.3812 29.7445 40.459 28.6068 40.459C27.4691 40.459 26.5469 41.3812 26.5469 42.5189C26.5469 43.6566 27.4691 44.5788 28.6068 44.5788Z",
    fill: "url(#paint9_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2809 40.7051C30.3486 41.0704 30.3347 41.4567 30.2245 41.8381C29.8461 43.1476 28.4778 43.9026 27.1682 43.5241C26.7869 43.414 26.4527 43.2198 26.1797 42.9676C26.3445 43.8571 26.9939 44.6227 27.9222 44.8909C29.2318 45.2693 30.6001 44.5144 30.9785 43.2048C31.2467 42.2766 30.9454 41.3189 30.2809 40.7051Z",
    fill: "url(#paint10_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6479 25.9227C41.011 25.9227 42.1161 24.8177 42.1161 23.4545C42.1161 22.0914 41.011 20.9863 39.6479 20.9863C38.2847 20.9863 37.1797 22.0914 37.1797 23.4545C37.1797 24.8177 38.2847 25.9227 39.6479 25.9227Z",
    fill: "url(#paint11_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6459 25.5144C40.7835 25.5144 41.7058 24.5921 41.7058 23.4545C41.7058 22.3168 40.7835 21.3945 39.6459 21.3945C38.5082 21.3945 37.5859 22.3168 37.5859 23.4545C37.5859 24.5921 38.5082 25.5144 39.6459 25.5144Z",
    fill: "url(#paint12_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7495 21.2461C40.916 21.5783 41.0098 21.9533 41.0098 22.3502C41.0098 23.7134 39.9048 24.8184 38.5416 24.8184C38.1447 24.8184 37.7697 24.7246 37.4375 24.5581C37.8428 25.3669 38.6792 25.9222 39.6454 25.9222C41.0085 25.9222 42.1136 24.8171 42.1136 23.454C42.1136 22.4878 41.5583 21.6514 40.7495 21.2461Z",
    fill: "url(#paint13_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6479 49.0009C41.011 49.0009 42.1161 47.8958 42.1161 46.5327C42.1161 45.1695 41.011 44.0645 39.6479 44.0645C38.2847 44.0645 37.1797 45.1695 37.1797 46.5327C37.1797 47.8958 38.2847 49.0009 39.6479 49.0009Z",
    fill: "url(#paint14_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6459 48.5925C40.7835 48.5925 41.7058 47.6703 41.7058 46.5326C41.7058 45.3949 40.7835 44.4727 39.6459 44.4727C38.5082 44.4727 37.5859 45.3949 37.5859 46.5326C37.5859 47.6703 38.5082 48.5925 39.6459 48.5925Z",
    fill: "url(#paint15_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7495 44.3242C40.916 44.6565 41.0098 45.0314 41.0098 45.4283C41.0098 46.7915 39.9048 47.8965 38.5416 47.8965C38.1447 47.8965 37.7697 47.8027 37.4375 47.6362C37.8428 48.445 38.6792 49.0003 39.6454 49.0003C41.0085 49.0003 42.1136 47.8952 42.1136 46.5321C42.1136 45.5659 41.5583 44.7294 40.7495 44.3242Z",
    fill: "url(#paint16_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0932 21.997C29.4564 21.997 30.5614 20.8919 30.5614 19.5288C30.5614 18.1656 29.4564 17.0605 28.0932 17.0605C26.7301 17.0605 25.625 18.1656 25.625 19.5288C25.625 20.8919 26.7301 21.997 28.0932 21.997Z",
    fill: "url(#paint17_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0912 21.5905C29.2288 21.5905 30.1511 20.6683 30.1511 19.5306C30.1511 18.393 29.2288 17.4707 28.0912 17.4707C26.9535 17.4707 26.0312 18.393 26.0312 19.5306C26.0312 20.6683 26.9535 21.5905 28.0912 21.5905Z",
    fill: "url(#paint18_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1948 17.3223C29.3613 17.6545 29.4551 18.0295 29.4551 18.4264C29.4551 19.7895 28.3501 20.8946 26.9869 20.8946C26.59 20.8946 26.215 20.8008 25.8828 20.6343C26.2881 21.4431 27.1245 21.9983 28.0907 21.9983C29.4538 21.9983 30.5589 20.8933 30.5589 19.5301C30.559 18.5639 30.0037 17.7275 29.1948 17.3223Z",
    fill: "url(#paint19_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4448 41.1669C35.8079 41.1669 36.913 40.0618 36.913 38.6987C36.913 37.3355 35.8079 36.2305 34.4448 36.2305C33.0816 36.2305 31.9766 37.3355 31.9766 38.6987C31.9766 40.0618 33.0816 41.1669 34.4448 41.1669Z",
    fill: "url(#paint20_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4427 40.7585C35.5804 40.7585 36.5027 39.8363 36.5027 38.6986C36.5027 37.5609 35.5804 36.6387 34.4427 36.6387C33.3051 36.6387 32.3828 37.5609 32.3828 38.6986C32.3828 39.8363 33.3051 40.7585 34.4427 40.7585Z",
    fill: "url(#paint21_linear_170_7147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5464 36.4902C35.7128 36.8225 35.8067 37.1974 35.8067 37.5944C35.8067 38.9575 34.7016 40.0626 33.3385 40.0626C32.9416 40.0626 32.5666 39.9688 32.2344 39.8022C32.6396 40.611 33.476 41.1663 34.4422 41.1663C35.8054 41.1663 36.9104 40.0612 36.9104 38.6981C36.9105 37.7319 36.3552 36.8954 35.5464 36.4902Z",
    fill: "url(#paint22_linear_170_7147)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_170_7147",
    x1: 36.3206,
    y1: 30.365,
    x2: 31.3673,
    y2: 35.9534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_170_7147",
    x1: 32.5749,
    y1: 32.2523,
    x2: 11.1741,
    y2: 24.3778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_170_7147",
    x1: 39.0552,
    y1: 36.8632,
    x2: 35.666,
    y2: 33.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_170_7147",
    x1: 32.9973,
    y1: 31.5063,
    x2: 36.1725,
    y2: 36.2055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_170_7147",
    x1: 36.5727,
    y1: 38.538,
    x2: 28.3172,
    y2: 17.0103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_170_7147",
    x1: 33.4101,
    y1: 26.2629,
    x2: 35.5934,
    y2: 30.2237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_170_7147",
    x1: 34.2066,
    y1: 27.8929,
    x2: 33.3434,
    y2: 25.3947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCEE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_170_7147",
    x1: 33.8588,
    y1: 28.3389,
    x2: 38.8733,
    y2: 23.2182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_170_7147",
    x1: 28.005,
    y1: 41.408,
    x2: 30.1883,
    y2: 45.3688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_170_7147",
    x1: 28.8094,
    y1: 43.0379,
    x2: 27.9461,
    y2: 40.5397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCEE21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_170_7147",
    x1: 28.4614,
    y1: 43.4858,
    x2: 33.4759,
    y2: 38.3653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_170_7147",
    x1: 38.7244,
    y1: 22.5311,
    x2: 41.9211,
    y2: 25.7277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A98F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_170_7147",
    x1: 39.942,
    y1: 23.8743,
    x2: 38.4191,
    y2: 21.7152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65E1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_170_7147",
    x1: 39.7311,
    y1: 24.4,
    x2: 43.1238,
    y2: 18.0901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_170_7147",
    x1: 38.7244,
    y1: 45.6092,
    x2: 41.9211,
    y2: 48.8059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A98F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_170_7147",
    x1: 39.942,
    y1: 46.9524,
    x2: 38.4191,
    y2: 44.7934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18CFFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65E1DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_170_7147",
    x1: 39.7311,
    y1: 47.478,
    x2: 43.1238,
    y2: 41.1681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0469BC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_170_7147",
    x1: 27.1697,
    y1: 18.6053,
    x2: 30.3664,
    y2: 21.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_170_7147",
    x1: 28.3873,
    y1: 19.9505,
    x2: 26.8644,
    y2: 17.7915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_170_7147",
    x1: 28.1765,
    y1: 20.4761,
    x2: 31.5692,
    y2: 14.1662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_170_7147",
    x1: 33.5213,
    y1: 37.7752,
    x2: 36.718,
    y2: 40.9719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_170_7147",
    x1: 34.7389,
    y1: 39.1184,
    x2: 33.2159,
    y2: 36.9594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_170_7147",
    x1: 34.528,
    y1: 39.6441,
    x2: 37.9207,
    y2: 33.3342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB272",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009245"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_7147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(18 17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt1);
export default __webpack_public_path__ + "static/media/ct1.96023f9c8e9ead530e8b5369676a2480.svg";
export { ForwardRef as ReactComponent };